import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

export const MAIN_LINKS = [
  { label: "Formule Intendance", href: "/intendance", highlight: true },
  { label: "Consommables & matériel", href: "/services/consommables-et-materiel" },
  { label: "Démarche qualité", href: "/qualite" },
  { label: "Recrutement", href: "/recrutement" },
  { label: "Contact", href: "/#contact" },
];

export const serviceHref = (s) => s.external || `/services/${s.slug}`;
/** Services déjà présents en lien direct dans le menu haut (évite les doublons dans le déroulant). */
const inMainLinks = (s) => MAIN_LINKS.some((l) => l.href === serviceHref(s));
export const menuServices = (services) => services.filter((s) => !inMainLinks(s));

/** Menu déroulant « Services » (desktop). */
export const ServicesMenu = ({ services, go, linkCls }) => {
  const [open, setOpen] = useState(false);
  const pick = (href) => { setOpen(false); go(href); };
  return (
    <div className="relative" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <button onClick={() => setOpen((v) => !v)} className={`${linkCls} flex items-center gap-1`} data-testid="nav-services">
        Services <ChevronDown size={14} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute left-0 top-full pt-3" data-testid="nav-services-menu">
          <div className="bg-white border border-neutral-200 rounded-xl shadow-xl p-2 w-72">
            {menuServices(services).map((s) => (
              <button key={s.slug} onClick={() => pick(serviceHref(s))} data-testid={`nav-service-${s.slug}`} className="w-full text-left px-3 py-2.5 rounded-lg hover:bg-neutral-50">
                <p className="text-sm font-semibold text-neutral-900">{s.title}</p>
                <p className="text-xs text-neutral-500 line-clamp-1">{s.tagline}</p>
              </button>
            ))}
            <button onClick={() => pick("/#services")} className="w-full text-left px-3 py-2 text-xs font-semibold text-brand hover:underline">Tous nos services →</button>
          </div>
        </div>
      )}
    </div>
  );
};

/** Menu mobile déroulé sous l'en-tête. */
export const MobileMenu = ({ services, go, onQuote }) => (
  <div className="md:hidden bg-white border-t border-neutral-200 mt-3 px-5 py-4 flex flex-col gap-3" data-testid="nav-mobile-menu">
    <p className="text-xs font-semibold tracking-widest text-neutral-400 uppercase">Services</p>
    {menuServices(services).map((s) => <button key={s.slug} onClick={() => go(serviceHref(s))} className="text-left text-base font-medium text-neutral-800 pl-3">{s.title}</button>)}
    <div className="border-t border-neutral-200 my-1" />
    {MAIN_LINKS.map((l) => <button key={l.href} onClick={() => go(l.href)} className={`text-left text-base font-medium ${l.highlight ? "text-brand" : "text-neutral-800"}`}>{l.label}</button>)}
    <button onClick={onQuote} className="bg-brand text-white font-semibold px-5 py-3 rounded-md mt-1">Demander un devis</button>
  </div>
);
